import React from "react";
import { motion } from "framer-motion";

function Slider(props) {
  // const style = {
  //     'left': `${props.score}%`,
  // }
  let delay = 2.5;
  if(props.delay != null) delay = props.delay;

  return (
    <div className="w-100 slider-bar mt5-ns mt2 mb5-ns mb2">
      <motion.div
        className="slider-indicator"
        animate={{ width: props.score+'%' }}
        transition={{
          delay: delay,
          duration:1,
        }}
        //style = {style}
      ></motion.div>
    </div>
  );
}

export default Slider;
